'use strict';

const React = require('react');
const connect = require('react-redux').connect;
const serialize = require('serialize-javascript');

class Index extends React.Component {
    render() {
        return (
            <html>
                <head>
                    <meta charSet="utf-8" />
                    <title>Disqus Embedded Comments</title>
                    <link rel="icon" type="image/png" href="/assets/img/favicon.png"/>
                    <link rel="stylesheet" href={`/${this.props.assets['styles.css']}`} />
                    <script src={`/${this.props.assets['app.js']}`} async={true} />
                </head>
                <body data-initialstate={this.props.initialStateAlt}>
                    {this.props.children}
                </body>
            </html>
        );
    }
}

module.exports = connect(state => {
    return {
        assets: state.assets,
        initialStateAlt: serialize(state, { isJSON: true }),
    };
})(Index);



/** WEBPACK FOOTER **
 ** ./common/index.js
 **/